import { render, staticRenderFns } from "./StatisticsHabits.vue?vue&type=template&id=cb86918c&scoped=true"
import script from "./StatisticsHabits.vue?vue&type=script&lang=js"
export * from "./StatisticsHabits.vue?vue&type=script&lang=js"
import style0 from "./StatisticsHabits.vue?vue&type=style&index=0&id=cb86918c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb86918c",
  null
  
)

export default component.exports